export const isCartPath = window.location.pathname.includes('/cart')
export const isCheckoutPath = window.location.pathname.includes('/checkout')
export const isGuestCheckoutPath = window.location.pathname.includes(
  '/guest_checkout'
)
